__turbopack_context__.v({
  "fade-in": "SubNavRight-module-scss-module__imho1W__fade-in",
  "root": "SubNavRight-module-scss-module__imho1W__root",
  "subNavRight": "SubNavRight-module-scss-module__imho1W__subNavRight",
  "subNavRightActive": "SubNavRight-module-scss-module__imho1W__subNavRightActive",
  "subNavRightDivider": "SubNavRight-module-scss-module__imho1W__subNavRightDivider",
});
